import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Outlet, useParams } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import {FaBars} from "react-icons/fa";
import {AiOutlineClose} from "react-icons/ai";
import { RootState } from '../../store/store';
import { useSelector } from 'react-redux';

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const nid = useSelector((state:RootState) => state.campaign.id);
  const mediatype = useSelector((state:RootState) => state.campaign.mediaType);

  const toggleSidebar = () => {
    setSidebarOpen(prevState => !prevState);
  };

  const handleOutsideClick = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setSidebarOpen(false);
    }
  };

  const handleItemClick = (item, path) => {
    navigate(path);
    setActiveItem(item);
  };

  useEffect(() => {
    if (sidebarOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [sidebarOpen]);

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes('/addcampaigns')) {
      setActiveItem('addCampaigns');
    } else {
      setActiveItem(null);
    }
  }, [location]);

  return (
    <div className="Sidebar">
      <Navbar bg="dark" data-bs-theme="dark" className="bg-body-tertiary p-3">
        <Navbar.Brand className='ms-5 custom-navbrand'>Nightlife Marketing Manager</Navbar.Brand>
        <div className="navbar-toggle" onClick={toggleSidebar}>
          {!sidebarOpen ? <FaBars className='mb-1 text-light'/> : <AiOutlineClose className='mb-1 text-light'/>}
        </div>
      </Navbar>
      
      <div ref={sidebarRef} className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header"></div>
        <h5 className='sidebar-menu mt-2'>
          Campaigns
        </h5>
        <ul>
          <li
            className={activeItem === 'addCampaigns' ? 'active' : ''}
            onClick={() => handleItemClick('addCampaigns', `/addcampaigns?id=${nid}&mediaType=${mediatype}`)}
          >
            Manage Campaigns
          </li>
        </ul>
      </div>
      
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
}

export default Sidebar;